export default __webpack_public_path__ + "static/media/dogButton.3726494a.png";